// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Flex, SystemProps, Text } from "flicket-ui";
import { useState } from "react";
import styled from "styled-components";
import { Select } from "~components";
import { SeatsIOSeat } from "~components/reservation/constants";
import { formatSeatLocation } from "~lib";
import PriceWithFee from "../../common/common.PriceWithFee";
import { ListItemDetails } from "./PricingListItemDetails";

const StyledListItem = styled(Flex)<SystemProps>`
  margin-bottom: ${(p) => p.theme.space[3]}px;

  justify-content: space-between;
  align-items: start;
`;

interface ListItemProps {
  seat: SeatsIOSeat;
  options: any[];
  handleTicketTypeChange: (id: any, newType: any) => void;
  showHiddenFees?: boolean;
}

export const ListItem = ({
  seat,
  options,
  handleTicketTypeChange,
  showHiddenFees = false,
}: ListItemProps) => {
  const hasTicketsAvailable = options?.length > 0;

  return (
    <StyledListItem mb={{ _: "6/4", md: 3 }} key={seat?.uuid}>
      <Flex flexDir="column" mr={1}>
        <Text fontSize={3} lineHeight="normal" fontWeight="heavy" color="N800">
          {/* don't pass zone label to avoid duplication */}
          {formatSeatLocation(
            undefined,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            seat.sectionLabel,
            seat.label,
            seat.objectType
          )}
        </Text>
        {hasTicketsAvailable && (
          <>
            <Text fontSize={2} lineHeight="normal" color="N600" mt="1/2">
              <PriceWithFee
                price={seat.originalPrice}
                ticketType={seat.ticketType}
                showFees={showHiddenFees}
              />
            </Text>
            <ListItemDetails
              seat={{ name: seat?.ticketType?.label }}
              description={seat?.ticketType?.description}
              restrictions={seat?.ticketType?.restrictions}
              addonImage={seat?.ticketType?.addonImage}
              ticketImage={seat?.ticketType?.ticketImage}
              ticketType={seat}
            />
          </>
        )}
      </Flex>
      <Flex minW="96px">
        {(() => {
          if (!hasTicketsAvailable) {
            return (
              <Text
                fontSize={2}
                textAlign="end"
                lineHeight="normal"
                color="N600"
                mt="1/2"
              >
                No tickets available
              </Text>
            );
          }

          const defaultOption =
            options.find((option) => option.value === seat?.ticketType?.id) ||
            options[0];

          return (
            <Select
              options={options}
              onChange={(value) =>
                handleTicketTypeChange(seat?.customId ?? seat.id, value)
              }
              defaultValue={{
                label: defaultOption.label,
                value: defaultOption.value,
              }}
              small
              selectProps={{
                isSearchable: false,
              }}
            />
          );
        })()}
      </Flex>
    </StyledListItem>
  );
};
